const childBehaviorIds = {
    CanAccessChild: 'CanAccessChild',

    // Management
    ShowChildPermissions: 'ShowChildPermissions',
    ManageChildPermissions: 'ManageChildPermissions',
    CanChangeBirthday: 'CanChangeBirthday',
    CanChangeProfileImage: 'CanChangeProfileImage',
    CanMoveChildToAnotherInstitution: 'CanMoveChildToAnotherInstitution',
    CanChangeGroup: 'CanChangeGroup',
    CanChangeStartEnddate: 'CanChangeStartEnddate',
    CanManageKibigWeb: 'CanManageKibigWeb',
    CanSeeChildCalendar: 'CanSeeChildCalendar',
    CanManageTags: 'CanManageTags',
    ShowChildNotes: 'ShowChildNotes',
    CanCreateChildNote: 'CanCreateChildNote',
    ChildNoteCanBeVisibleToParents: 'ChildNoteCanBeVisibleToParents',
    CanViewSafeguardingDisclosures: 'CanViewSafeguardingDisclosures',
    CanCheckSleep: 'CanCheckSleep',
    CanManageBasicChildInfo: 'CanManageBasicChildInfo',
    CanManageHealthInformation: 'CanManageHealthInformation',
    CanManageSensitiveInformation: 'CanManageSensitiveInformation',
    CanCreateRelation: 'CanCreateRelation',
    CanManageDachChildExtraFields: 'CanManageDachChildExtraFields',
    ShowDachChildExtraFields: 'ShowDachChildExtraFields',

    // Bookings
    ShowChildPlans: 'ShowChildPlans',
    ShowChildBookings: 'ShowChildBookings',
    ShowChildPurchases: 'ShowChildPurchases',
    CanSetCustomDiscount: 'CanSetCustomDiscount',

    // Billing
    ShowChildBilling: 'ShowChildBilling',
    CanManageChildBillPayers: 'CanManageChildBillPayers',
    ShowGenericFunding: 'ShowGenericFunding',
    CanManageGenericFunding: 'CanManageGenericFunding',
    ShowDepositWidget: 'ShowDepositWidget',

    // Meal registration
    CanRegisterMeals: 'CanRegisterMeals',

    ShowInstitutionInfo: 'ShowInstitutionInfo',
    ShowSensitiveInformation: 'ShowSensitiveInformation',
    ShowHealthInformation: 'ShowHealthInformation',
    ShowLearningJourney: 'ShowLearningJourney',

    // Messaging
    CanSendPostTo: 'CanSendPostTo',
    CanSendMessageTo: 'CanSendMessageTo',

    // KeyWorker
    CanSeeKeyWorker: 'CanSeeKeyWorker',
    CanAssignKeyWorker: 'CanAssignKeyWorker',

    // Checkin
    CanCheckinChild: 'CanCheckinChild',
    CanCheckoutChild: 'CanCheckoutChild',
    CanPlanCheckoutsForChild: 'CanPlanCheckoutsForChild',
    CanSwitchRoom: 'CanSwitchRoom',
    ShowWarningOnChildCheckin: 'ShowWarningOnChildCheckin',

    // Health
    SensitiveInformationRequiresPassword: 'SensitiveInformationRequiresPassword',

    // Allergeis
    ShowAllergyAndDietConsiderationsAboutTab: 'ShowAllergyAndDietConsiderationsAboutTab',
    CanManageAllergyAndDietConsiderations: 'CanManageAllergyAndDietConsiderations',

    // IsActive
    IsActive: 'IsActive',

    // Events
    CanManageNaps: 'CanManageNaps',
    CanManageChildActions: 'CanManageChildActions',
    CanManageDiaperChanges: 'CanManageDiaperChanges',
    CanRegisterCream: 'CanRegisterCream',

    // Learning
    CanViewLearningSummary: 'CanViewLearningSummary',

    // Accident/Incident Reports
    HasAccidentReports: 'HasAccidentReports',
    CanCreateAccidentReports: 'CanCreateAccidentReports',

    // Kiku
    ShowExtraKikuFields: 'ShowExtraKikuFields',
    CanUpdateExtraKikuFields: 'CanUpdateExtraKikuFields',

    // Custom ID
    ShowAutoGeneratedId: 'ShowAutoGeneratedId',
    CanOverrideAutoGeneratedId: 'CanOverrideAutoGeneratedId',

    // Allergies and dietary considerations
    ShowAllergyAndDietConsiderations: 'ShowAllergyAndDietConsiderations',

    // Sibling linking
    ShowSiblings: 'ShowSiblings',
    CanRemoveSiblings: 'CanRemoveSiblings',

    // Doctor section
    ShowDoctorInformation: 'ShowDoctorInformation',
    CanManageDoctorInformation: 'CanManageDoctorInformation',

    // Combined bookings and invoices tab on child profile
    ShowCombinedBookingsAndInvoicesTab: 'ShowCombinedBookingsAndInvoicesTab',

    // Adding absence
    CanReportChildAbsentLeave: 'CanReportChildAbsentLeave',

    CanSeeChildReasonForLeaving: 'CanSeeChildReasonForLeaving',

    // Can register temperature
    CanRegisterTemperature: 'CanRegisterTemperature',
};

export default childBehaviorIds;
